import type { DraftStateUpdater } from 'utils/react/StateProxy';
import type { ApiRequestFunction } from 'utils/request/useApi';
import type { WebHooksState } from '../WebHooksState';

export function makeLoadCACerts(
  updateState: DraftStateUpdater<WebHooksState>,
  apiRequest: ApiRequestFunction,
) {
  return async (): Promise<void> => {
    const caCerts = await apiRequest({
      url: '/settings/ca',
      method: 'GET',
    });

    updateState((draft) => {
      if (Array.isArray(caCerts)) {
        draft.caCerts = caCerts.map(({ id, name }) => ({ id, name }));
      }
    });
  };
}
